// import { Component, OnInit, Input } from "@angular/core";
import { TalentService } from "../talent.service";
import { FormControl } from "@angular/forms"
import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit,
  Input,
  SimpleChanges,
  NgZone,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CustomDialogComponent } from "../custom-dialog/custom-dialog.component";
@Component({
    selector: "app-address-list",
    templateUrl: "./address-list.component.html",
    styleUrls: ["./address-list.component.css"],
    standalone: false
})
export class AddressListComponent implements OnInit {
  @Input() create_new: boolean = false;
  @Output() select_primary = new EventEmitter<any>();
  @Input() selected_id: number = 0;
  selected_address: object;
  @Input() client_id: number;
  @Input() parent_view: string;

  address_list = [];
  show_new: boolean = false;
  public zoom: number;

  public map_marker_coords: google.maps.LatLngLiteral = { 
    lat: 40.7551279,
    lng: -73.9883636
  }
  public latitude: number;
  public longitude: number;
  predictions: google.maps.places.AutocompletePrediction[] = [];
  private autoCompleteService: google.maps.places.AutocompleteService;
  public addressCtrl = new FormControl('');
  formated_location: string;

  address_components: { label: string,
    comment: string,
    street: string,
    street_no: string,
    city: string,
    state: string,
    zipcode: string,
    country: string,
    latitude: number,
    longitude: number
  } = {
    label: null,
    comment: null,
    street: null,
    street_no: null,
    city: null,
    state: null,
    zipcode: null,
    country: null,
    latitude: null,
    longitude: null
  };

  constructor(private talentService: TalentService, public dialog: MatDialog, private zone: NgZone) {}

  ngOnInit() {
    this.autoCompleteService = new google.maps.places.AutocompleteService();

    this.addressCtrl.valueChanges.subscribe(value => {
    
      if (!value) {
        this.predictions = [];
        return;
      }

      this.autoCompleteService.getPlacePredictions(
        { input: value },
        predictions => {
          this.predictions = predictions ?? [];
        }
      );
    });
    this.zoom = 12;
    this.latitude = 40.7551279;
    this.longitude = -73.9883636;
    // this.setCurrentPosition();
    this.getAddressList();
  }

  getAddressList() {
    this.talentService.getAddress(this.client_id).subscribe((res) => {
      this.address_list = res;
      for (let a of res) {
        if (a["id"] == this.selected_id) {
          this.selected_address = a;
        }
      }
    });
  }

  parseAddress(
  components: google.maps.GeocoderAddressComponent[]
  ) {
    const get = (type: string) =>
      components.find(c => c.types.includes(type))?.long_name ?? '';

    return {
      streetNumber: get('street_number'),
      street: get('route'),
      city: get('locality'),
      state: get('administrative_area_level_1'),
      zip: get('postal_code'),
      country: get('country')
    };
  }

  onPlaceSelected(prediction: google.maps.places.AutocompletePrediction) {
  const placesService = new google.maps.places.PlacesService(
    document.createElement('div')
  );

  console.log("onPlaceSelected happened")
  const outer_this = this

  placesService.getDetails(
    {
      placeId: prediction.place_id,
      fields: ['address_components', 'geometry']
    },
    place => {
      if (!place?.address_components) return;

      this.zone.run(() =>
      {
        this.latitude = place.geometry.location.lat()
        this.longitude = place.geometry.location.lng()

        this.map_marker_coords = { lat: this.latitude, lng: this.longitude }
        const address = this.parseAddress(place.address_components);
        this.address_components = {
        label: this.address_components.label,
        comment: this.address_components.comment,
        street: address.street,
        street_no: address.streetNumber,
        city: address.city,
        state: address.state,
        zipcode: address.zip,
        country: address.country,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()

      }
        outer_this.addressCtrl = new FormControl(address.streetNumber + " " + address.street + ", " + address.city)
        

    })

      
    }
  );
}


  ngOnChanges(changes: SimpleChanges) {
    if (this.create_new) {
      this.getAddressList();
      this.selected_address = null;
    }
  }

  clickNewAddress() {
    this.show_new = !this.show_new;
    this.latitude = 40.75512;
    this.longitude = -73.99065;
    this.map_marker_coords = { lat: this.latitude, lng: this.longitude }
    this.zoom = 13;
    this.address_components = {
      label: "",
      comment: "",
      street: "",
      street_no: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      longitude: 0,
      latitude: 0
    };
  }

  addNewAddress() {
    let validate = [];
    if (this.address_components["label"] == "") {
      validate.push("Label filed missing, please fill it");
    }
    if (
      !this.address_components["country"] &&
      !this.address_components["state"]
    ) {
      validate.push(
        "Address field missing, Please fill the Address in the first line"
      );
    }
    if (validate.length != 0) {
      let confirm_data = {};

      confirm_data["type"] = "validate";
      confirm_data["title"] =
        "Please fix the following issue(s) to create a new address";
      confirm_data["validate"] = validate;

      this.dialog.open(CustomDialogComponent, {
        maxWidth: "800px",
        data: confirm_data,
      });
    } else {
      if (this.address_components["label"]) {
        this.address_components["client_id"] = this.client_id;
        this.address_components["latitude"] = this.latitude;
        this.address_components["longitude"] = this.longitude;
        this.talentService
          .addAddress(this.address_components)
          .subscribe((res) => {
            this.address_list.unshift(res);
            if (this.selected_id == 0) {
              this.selected_id = res["id"];
              this.selected_address = res;
            }
          });
        this.clickNewAddress();
      }
    }
  }

  removeAddress(address_id, label) {
    let title = "Are you sure you want to remove this Address?";
    let message = "Label: " + label;
    let confirm_data = { title: title, message: message, type: "confirm" };
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      maxWidth: "600px",
      data: confirm_data,
    });

    dialogRef.afterClosed().subscribe((dialogRef) => {
      if (dialogRef) {
        let next_primary_address = this.selected_id;
        if (address_id == this.selected_id) {
          if (this.address_list.length > 1) {
            for (let a of this.address_list) {
              if (a.id != address_id) {
                next_primary_address = a.id;
                break;
              }
            }
          } else {
            next_primary_address = 0;
          }
        }

        let data = {
          address_id: address_id,
          next_primary_address: next_primary_address,
          client_id: this.client_id,
        };
        this.talentService.removeAddress(data).subscribe((res) => {
          this.address_list = this.address_list.filter(
            (item) => item.id != address_id
          );
          if (address_id == this.selected_id) {
            this.selected_id = next_primary_address;
            this.selected_address = null;
            for (let a of this.address_list) {
              if (a["id"] == this.selected_id) {
                this.selected_address = a;
              }
            }
          }
        });
      }
    });
  }

  select_star(address_id) {
    this.select_primary.emit({
      client_id: this.client_id,
      address_id: address_id,
    });

    this.selected_id = address_id;

    for (let a of this.address_list) {
      if (a["id"] == this.selected_id) {
        this.selected_address = a;
      }
    }
  }
}
